module.exports = __webpack_public_path__ + "img/jiaofeilogo.c7d62ce0.png";